import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/pro-solid-svg-icons';
import { Card } from '@quero-delivery/quero-components-web';
import styles from './approval-mat.module.scss';
import { useGetDeliverymanPreRegister } from './api/get-deliveryman-pre-registration';
import { ApprovalMatForm } from './components/approval-mat-form';
import { SHOW_DOCS_VALIDATION } from '../pre-registration/constants';
import { DisapprovalLabel } from '../motoboy-details/components/disapproval-label';
import { ENUM_STATUS_PRE_REGISTRATION } from '../constants';

function ApprovalMat() {
  const navigate = useNavigate();

  const { deliverymanId = '' } = useParams<{ deliverymanId: string }>();

  const { data: deliveryman, isLoading } = useGetDeliverymanPreRegister(
    {
      deliverymanId,
    },
    {
      enabled: !!deliverymanId,
    },
  );

  if (
    deliveryman?.preRegistration &&
    !isLoading &&
    !SHOW_DOCS_VALIDATION.includes(deliveryman.preRegistration.status)
  ) {
    return <p>Entregador não encontrado</p>;
  }

  const hasNewDocs =
    deliveryman?.preRegistration?.status ===
    ENUM_STATUS_PRE_REGISTRATION.REPROVED_NEW_DOCUMENTATION_PROVIDED;

  return (
    <Card type="none" loading={isLoading} className={styles.container}>
      {hasNewDocs && deliveryman?.preRegistration?.status && (
        <DisapprovalLabel
          disapprovalStatus={deliveryman?.preRegistration?.status}
          isAbsoluteStyle
        />
      )}

      <div className={styles.breadcrumbs} onClick={() => navigate(-1)}>
        <FontAwesomeIcon icon={faAngleLeft} size="lg" />
        <span>Esteira de aprovação nuvem /</span>
        <span>{deliveryman?.nome || 'Entregador'}</span>
      </div>

      {deliveryman ? <ApprovalMatForm deliveryman={deliveryman} /> : null}
    </Card>
  );
}

export { ApprovalMat };
